module.exports = __webpack_public_path__ + "img/qcyn-footer-bg.07d75ea6.png";